export default {"src":"/_next/static/image/public/images/ic_gps_address.490b0149f4e3d9c046bff7e074d6c1dd.svg","height":21,"width":20};